<template>
  <div class="edit">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>学生管理</Breadcrumb-item>
        <Breadcrumb-item href="/user/userTrackList">学员跟踪记录</Breadcrumb-item>
        <Breadcrumb-item>添加跟踪记录-报名失败记录</Breadcrumb-item>
      </Breadcrumb>
    </div>

    <Form ref="form" :model="formValidate" :rules="ruleValidate" :label-width="90" class="form">
      <Row>
        <Col :sm="11" :md="4">
          <Form-item label="学生ID" prop="uid">
            <Input readonly v-model.number="formValidate.uid"></Input>
          </Form-item>
        </Col>
        <Col :sm="11" :md="6">
          <Form-item label="学生姓名" prop="nickname">
            <Input readonly v-model="formValidate.nickname"></Input>
          </Form-item>
        </Col>
        <Col :sm="11" :md="6">
          <Form-item label="课程顾问" prop="adviserName">
            <Input readonly v-model="formValidate.adviserName"></Input>
          </Form-item>
        </Col>
        <Col :sm="11" :md="6">
          <Form-item label="学习导师" prop="studyAdviserName">
            <Input readonly v-model="formValidate.studyAdviserName"></Input>
          </Form-item>
        </Col>
      </Row>
      <Row>
        <Col :sm="22" :md="18">
          <Form-item label="内容" prop="content">
            <div>&nbsp;</div>
            <div>报名失败原因：</div>
            <Checkbox v-model="formValidate.teacherReason" true-value="1" false-value="0" @on-change="onChange">老师原因</Checkbox>
            <Checkbox v-model="formValidate.equipmentReason" true-value="1" false-value="0" @on-change="onChange">设备原因</Checkbox>
            <Checkbox v-model="formValidate.netReason" true-value="1" false-value="0" @on-change="onChange">网络原因</Checkbox>
            <Checkbox v-model="formValidate.highPrice" true-value="1" false-value="0" @on-change="onChange">价格偏高</Checkbox>
            <Checkbox v-model="formValidate.registerOtherAgencies" true-value="1" false-value="0" @on-change="onChange">已报名其它机构</Checkbox>
            <Checkbox v-model="formValidate.likeShortTermCourse" true-value="1" false-value="0" @on-change="onChange">意向短期课程</Checkbox>
            <Checkbox v-model="formValidate.contrastiveCompetition" true-value="1" false-value="0" @on-change="onChange">对比竞品</Checkbox>
            <Checkbox v-model="formValidate.inThinking" true-value="1" false-value="0" @on-change="onChange">考虑中</Checkbox>
            <Checkbox v-model="formValidate.childNotCooperate" true-value="1" false-value="0" @on-change="onChange">孩子不配合</Checkbox>
            <Checkbox v-model="formValidate.worryEffect" true-value="1" false-value="0" @on-change="onChange">担心效果</Checkbox>
            <Checkbox v-model="formValidate.lossOfUnion" true-value="1" false-value="0" @on-change="onChange">学员失联</Checkbox>
            <Input type="textarea" v-model="formValidate.specialRemark" placeholder="其它/备注" @on-change="onChange"></Input>
          </Form-item>
        </Col>
      </Row>
      <Row>
        <Col :sm="11" :md="9">
          <Form-item label="下次联系日期" prop="nextHandlerTime">
            <Date-picker type="date" format="yyyy-MM-dd" @on-change="nextTimeDateChange"
              :value="formValidate.nextHandlerTime"></Date-picker>
          </Form-item>
        </Col>
        <Col :sm="11" :md="7">
          <Form-item label="下次联系人" prop="nextHandlerId">
            <Select v-model.number="formValidate.nextHandlerId" filterable>
              <Option v-for="item in nextHandler"
                :value="item.id" :key="item.id">{{ item.nickname }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :sm="11" :md="6">
        <Form-item label="状态" prop="operateStatus">
          <Select v-model="formValidate.operateStatus">
            <Option value="0">未处理</Option>
            <Option value="1">已处理</Option>
          </Select>
        </Form-item>
        </Col>
      </Row>
      <Form-item>
        <Button type="primary" @click="handleSubmit()">提交</Button>
      </Form-item>
    </Form>
  </div>
</template>
<script>
  import dates from '@/tools/date/dates.js'
  export default {
    data () {
      return {
        nextHandler: [],
        uidReadonly: false,
        formValidate: {
          id: '',
          uid: null,
          nickname: '',
          adviserName: '',
          studyAdviserName: '',
          content: '',
          nextHandlerTime: dates.today(),
          nextHandlerId: null,
          operateStatus: '0',
          teacherReason: '0',
          equipmentReason: '0',
          netReason: '0',
          highPrice: '0',
          registerOtherAgencies: '0',
          likeShortTermCourse: '0',
          contrastiveCompetition: '0',
          inThinking: '0',
          childNotCooperate: '0',
          worryEffect: '0',
          lossOfUnion: '0',
          specialRemark: '',
        },
        ruleValidate: {
          uid: [
            { type: 'number', required: true, message: '学生ID不能为空', trigger: 'blur' },
            { pattern: /^[0-9]+$/, message: '学生ID只能为数字', trigger: 'blur' },
          ],
          content: [
            { required: true, message: '内容不能为空', trigger: 'blur' },
            { type: 'string', max: 200, message: '内容不能超过200个字', trigger: 'blur' }
          ]
        },
      }
    },
    created () {
    },
    mounted () {
      let self = this
      let row = self.$route.query.row
      self.formValidate.uid = row.uid
      self.$http.get('/userList/queryByUid?uid=' + self.formValidate.uid).then(function (res) {
        self.formValidate.nickname = res.data.nickname
        self.formValidate.adviserName = res.data.adviserName
        self.formValidate.studyAdviserName = res.data.studyAdviserName
      })
      this.$http.post('/adminUser/listByCondition', {status: 1}).then(function (res) {
        self.nextHandler = res.data
      })

      this.getUserInfo()
    },
    methods: {
      nextTimeDateChange (value) {
        this.formValidate.nextHandlerTime = value
        console.log(this.formValidate.nextHandlerTime)
      },
      getUserInfo () {
        let self = this
        if (!self.formValidate.uid) {
          return
        }
        self.$http.post('/user/queryById', {'uid': self.formValidate.uid}).then(function (res) {
          if (!res || !res.data) {
            return
          }
          let user = res.data
          self.formValidate.nickname = user.nickname
          self.formValidate.adviserName = user.adviserName
          self.formValidate.studyAdviserName = user.studyAdviserName
        })
      },
      handleSubmit () {
        let self = this
        this.$refs.form.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            return
          }

          self.$http.post('/userTrack/buyFail', self.formValidate).then(function (res) {
            if (res && res.data > 0) {
              self.$Message.success('提交成功!')
              self.$router.push('/user/userTrackList')
            }
          })
        })
      },
      onChange () {
        var arr = []
        if (this.formValidate.teacherReason === '1') {
          arr.push('老师原因')
          arr.push('、')
        }
        if (this.formValidate.equipmentReason === '1') {
          arr.push('设备原因')
          arr.push('、')
        }
        if (this.formValidate.netReason === '1') {
          arr.push('网络原因')
          arr.push('、')
        }
        if (this.formValidate.highPrice === '1') {
          arr.push('价格偏高')
          arr.push('、')
        }
        if (this.formValidate.registerOtherAgencies === '1') {
          arr.push('已报名其它机构')
          arr.push('、')
        }
        if (this.formValidate.likeShortTermCourse === '1') {
          arr.push('意向短期课程')
          arr.push('、')
        }
        if (this.formValidate.contrastiveCompetition === '1') {
          arr.push('对比竞品')
          arr.push('、')
        }
        if (this.formValidate.inThinking === '1') {
          arr.push('考虑中')
          arr.push('、')
        }
        if (this.formValidate.childNotCooperate === '1') {
          arr.push('孩子不配合')
          arr.push('、')
        }
        if (this.formValidate.worryEffect === '1') {
          arr.push('担心效果')
          arr.push('、')
        }
        if (this.formValidate.lossOfUnion === '1') {
          arr.push('学员失联')
          arr.push('、')
        }
//        去掉最后一个“、”
        arr.splice(-1, 1, ' ')

        if (this.formValidate.specialRemark) {
          arr.push('备注：')
          arr.push(this.formValidate.specialRemark)
        }

        this.formValidate.content = arr.join(' ')
      }
    },
    watch: {
    }
  }
</script>



// WEBPACK FOOTER //
// AddOrderFailRecords.vue?5b46c04f